import { OrderRejectionReason } from '../../../../../services/exports/Constants';

export default {
  header: 'Annuller ordre',
  title: 'Afvis aldrig for hurtigt!',
  text: 'Hvis der er et mindre problem med ordren, så ring til kunden og find en løsning.',
  reasons: {
    [OrderRejectionReason.ItemUnavailable]: 'Varer er udsolgt',
    [OrderRejectionReason.ClosingSoon]: 'Butikken er lukket',
    [OrderRejectionReason.StoryBusy]: 'Butikken har for travlt',
    [OrderRejectionReason.CustomerMistake]: 'Kunden ringede for at annullere',
    [OrderRejectionReason.DriverNotArrived]: 'Chauffør er ikke ankommet',
  },
  buttons: {
    confirm: 'Bekræft',
  },
};
